exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".connection-monitor-page .cols-cards-info[data-v-380d9bd2]{margin-top:10px}", ""]);

// exports
